.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  width: fit-content;
}

.hidden-remote-shell {
  visibility: hidden;
}
